export default "__VITE_ASSET__Bx4sKbb___"